import React from 'react';
import { Award, Globe, ShieldCheck } from 'lucide-react';

const Partners = () => {
  const partners = [
    { name: 'Accenture', logo: '/images/partners/affi-1.png' },
    { name: 'Uber Technologies', logo: '/images/partners/affi-2.png' },
    { name: 'Amazon', logo: '/images/partners/affi-3.png' },
    { name: 'GEMS Wellington International School', logo: '/images/partners/affi-4.png' },
    { name: 'Reliance Industries', logo: '/images/partners/affi-5.png' },
    { name: 'Shell', logo: '/images/partners/affi-6.jpg' },
  ];

  const stats = [
    { icon: Award, value: '500+', label: 'Projects Completed' },
    { icon: Globe, value: '25+', label: 'Countries Served' },
    { icon: ShieldCheck, value: 'ISO 9001', label: 'Certified Quality Management' }
  ];

  return (
    <section id="partners" className="relative pt-24 pb-20 bg-silk-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-24">
          <div>
            <span className="text-gold-deep font-serif italic text-xl tracking-wider block mb-2">Our Network</span>
            <h2 className="text-5xl md:text-7xl font-serif font-bold text-hillpoint">
                Trusted by <span className="italic text-gold-deep">Leaders</span>
            </h2>
          </div>
        </div>

        {/* Stats - Maximalist Overlay Style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 md:mb-16 border-t border-b border-hillpoint/10 py-12">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div 
                    key={index} 
                    className="text-center group relative p-8 hover:bg-white hover:shadow-2xl transition-all duration-500 rounded-lg border border-transparent hover:border-gold/20"
                >
                  <div className="absolute top-4 right-4 opacity-20 group-hover:opacity-100 transition-opacity duration-500">
                    <Icon className="w-12 h-12 text-gold" />
                  </div>
                  <div className="text-[clamp(3rem,5vw,5rem)] font-serif font-bold text-hillpoint mb-0 leading-none group-hover:text-gold transition-colors duration-500">
                    {stat.value}
                  </div>
                  <div className="text-charcoal-light font-bold tracking-[0.2em] uppercase text-sm mt-4 group-hover:text-hillpoint transition-colors">
                    {stat.label}
                  </div>
                </div>
              );
            })}
        </div>

        {/* Infinite Marquee */}
        <div className="relative w-full overflow-hidden bg-white py-12 border-y border-stone-100">
            <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10"></div>
            <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10"></div>
            
            {/* Two identical sets sliding -50% per loop, so the band never empties */}
            <div className="flex animate-marquee whitespace-nowrap w-max">
                {[0, 1].map((setIndex) => (
                    <div key={setIndex} aria-hidden={setIndex === 1} className="flex items-center gap-16 pr-16">
                        {partners.map((partner, index) => (
                            <div
                                key={index}
                                className="flex-shrink-0 w-48 h-24 flex items-center justify-center opacity-80 transition-all duration-500 hover:opacity-100 hover:scale-110"
                            >
                                <img
                                    src={partner.logo}
                                    alt={`${partner.name} logo`}
                                    loading="lazy"
                                    width={192}
                                    height={96}
                                    className="max-w-full max-h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
